import { idURL, kadhavuExpUrl } from 'endpoints';
import { fetch } from '@nackle/umbrella';
import { getString } from '@nackle/intl-tools';
import { endLoading, setAlertMessage, setError, startLoading } from './app-dux';
import { getPrimaryExperienceUrl } from './interaction-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	choices: [],
	solutionName: '',
	showDirectAccess: false
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_CHOICE_DATA = 'state/setChoiceData';
export const SET_SOLUTION_NAME = 'state/setSolutionName';

/*******************************************************************************
 * Reducer
 */
export default function choiceReducer( state = initialState, action ) {
	switch ( action.type ) {
		case SET_CHOICE_DATA: {
			return {
				...state,
				choices: action?.choiceData?.choices || [],
				showDirectAccess: action?.choiceData?.showDirectAccess
			};
		}
		// Setting up only first solution into the store
		case SET_SOLUTION_NAME: {
			return {
				...state,
				solutionName: action?.solutionName
			};
		}
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */
export function setChoiceData( choiceData ) {
	return {
		type: SET_CHOICE_DATA,
		choiceData: choiceData
	};
}

export function setSolutionName( name ) {
	return {
		type: SET_SOLUTION_NAME,
		solutionName: name
	};
}

export const getSolutions = () => async( dispatch, getState ) => {

	try {

		const res = await fetch( `${ kadhavuExpUrl }/solution`, {
			method: 'GET',
			headers: { 'content-type': 'application/json' }
		} );

		const data = await res.json();

		if ( data.errors ) {
			throw data.errors;
		}

		if ( data.name ) {
			dispatch( setSolutionName( data.name ) );
		} else {
			dispatch( setError( [ { code: 'errors.content.generic' } ] ) );
		}
	} catch ( error ) {
		console.error( 'error while getting solution:', JSON.stringify( error ) );
		dispatch( setError( [ { code: 'errors.content.generic' } ] ) );
	}
};

export const getChoiceList = ( interactionId, idUrl ) => async dispatch => {
	try {
		dispatch( startLoading() );
		// idUrl is passed from DMSA only for host transfer to if that's getting passed we need to take that into account as the autority is built for that instead of taking it from endpoints
		const res = await fetch( `${ idUrl ? idUrl : idURL }/interaction/${ encodeURIComponent( interactionId ) }/choices`, {
			method: 'GET',
			headers: { 'content-type': 'application/json' },
		} );

		const data = await res.json();

		if ( data.success ) {
			dispatch( setChoiceData( data ) );
			if ( data.showDirectAccess && data.choices.length === 1 ) {
				await dispatch( getSolutions() );
			}
		} else if ( !data.success && data.error === 'id.error.notFoundSession' ) {
			sessionStorage.clear();
            const primaryExperienceUrl = await dispatch( getPrimaryExperienceUrl() );
            window.location.href = primaryExperienceUrl;
		} else {
			dispatch( setAlertMessage( getString( 'login.error.unknownError' ), 'error' ) );
		}
	} catch ( err ) {
		dispatch( setAlertMessage( getString( 'login.error.unknownError' ), 'error' ) );
	} finally {
		dispatch( endLoading() );
	}
};

export const submitChoice = ( interactionId, choice, idUrl ) => async dispatch => {
	dispatch( startLoading() );
	const form = document.createElement( 'form' );
	form.method = 'POST';
	// idUrl is passed from DMSA only for host transfer to if that's getting passed we need to take that into account as the autority is built for that instead of taking it from endpoints
	form.action = `${ idUrl ? idUrl : idURL }/interaction/${ encodeURIComponent( interactionId ) }/choices`;

	const settingsInput = document.createElement( 'input' );
	settingsInput.type = 'hidden';
	settingsInput.name = 'settings';
	settingsInput.value = choice.settings || '';
	form.appendChild( settingsInput );

	const directAccessInput = document.createElement( 'input' );
	directAccessInput.type = 'hidden';
	directAccessInput.name = 'directAccess';
	directAccessInput.value = ( choice.directAccess || false ).toString();
	form.appendChild( directAccessInput );

	document.body.appendChild( form );
	form.submit();
};